import './index.css'

function PageTitle({text,heading}){
    return <div className='app-title-holder'>
    <h2 className='big-text'>{heading}</h2>
    <p className='small-text'>{text}</p>
    </div>
}

export default PageTitle